<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_Facebook_AccessToken')"
      prop="access_tokej"
    >
      <el-input v-model="model.params.access_token" />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: {
    RestFormItem
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'facebook')
      this.$set(this.model, 'channel', 'facebook')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Facebook.vue